// begin of liveview dependencies for ie 11
import "mdn-polyfills/Object.assign";
import "mdn-polyfills/CustomEvent";
import "mdn-polyfills/String.prototype.startsWith";
import "mdn-polyfills/Array.from";
import "mdn-polyfills/NodeList.prototype.forEach";
import "mdn-polyfills/Element.prototype.closest";
import "mdn-polyfills/Element.prototype.matches";
import "mdn-polyfills/Node.prototype.remove";
import "child-replace-with-polyfill";
import "url-search-params-polyfill";
import "formdata-polyfill";
import "classlist-polyfill";
import "@webcomponents/template";
import "shim-keyboard-event-key";

// end of liveview deps
import { Hooks as FluxonHooks, DOM as FluxonDOM } from '../../deps/fluxon';
import { Socket, LongPoll } from "phoenix";
import { LiveSocket } from "phoenix_live_view";
import { createLiveToastHook } from "../../deps/live_toast";


import {
  TippyHook,
  CopyToClipboardHook,
  StripeElementsHook,
  StripeElementsExistingCardHook,
  WaveSurferHook,
} from "./hooks";
// import LiveReact, { initLiveReact } from "phoenix_live_react"

console.log("loading liveview.js");

let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content");
// let hooks = { ...window.Hooks, LiveReact }
let hooks = { ...window.Hooks };

hooks.RecaptchaHook = {
  mounted() {
    console.log("recaptcha hook mounted ", this);
    const key = this.el.getAttribute("data-recaptcha-key");

    this.handleEvent("trigger_recaptcha", (t) => {
      console.log("got handleEvent trigger_recaptcha");
      window.grecaptcha.execute(key, { action: "submit" }).then((token) => {
        console.log("handleEvent: recaptcha hook token is ", token);
        this.pushEvent("recaptcha-token", { event: "mount", token: token });
      });
    });

    window.grecaptcha.ready(() => {
      // setTimeout(() => {
      window.grecaptcha.execute(key, { action: "submit" }).then((token) => {
        console.log("MOUNT: recaptcha hook token is ", token);
        this.pushEvent("recaptcha-token", { event: "mount", token: token });
      });
      // }, 5000);
    });
  },
};

hooks.Mermaid = {
  mounted() {
    console.log("mount mermaid");
    window.mermaid.init();
  },

  updated() {
    console.log("updating mermaid");
  },

  destroyed() {
    console.log("destryoing mermaid");
  },
};


hooks.Menu = {
  getAttr(name) {
    let val = this.el.getAttribute(name)
    if (val === null) { throw (new Error(`no ${name} attribute configured for menu`)) }
    return val
  },
  reset() {
    this.enabled = false
    this.activeClass = this.getAttr("data-active-class")
    this.deactivate(this.menuItems())
    this.activeItem = null
    window.removeEventListener("keydown", this.handleKeyDown)
  },
  destroyed() { this.reset() },
  mounted() {
    this.menuItemsContainer = document.querySelector(`[aria-labelledby="${this.el.id}"]`)
    this.reset()
    this.handleKeyDown = (e) => this.onKeyDown(e)
    this.el.addEventListener("keydown", e => {
      if ((e.key === "Enter" || e.key === " ") && e.currentTarget.isSameNode(this.el)) {
        this.enabled = true
      }
    })
    this.el.addEventListener("click", e => {
      if (!e.currentTarget.isSameNode(this.el)) { return }

      window.addEventListener("keydown", this.handleKeyDown)
      // disable if button clicked and click was not a keyboard event
      if (this.enabled) {
        window.requestAnimationFrame(() => this.activate(0))
      }
    })
    this.menuItemsContainer.addEventListener("phx:hide-start", () => this.reset())
  },
  activate(index, fallbackIndex) {
    let menuItems = this.menuItems()
    this.activeItem = menuItems[index] || menuItems[fallbackIndex]
    this.activeItem.classList.add(this.activeClass)
    this.activeItem.focus()
  },
  deactivate(items) { items.forEach(item => item.classList.remove(this.activeClass)) },
  menuItems() { return Array.from(this.menuItemsContainer.querySelectorAll("[role=menuitem]")) },
  onKeyDown(e) {
    if (e.key === "Escape") {
      document.body.click()
      this.el.focus()
      this.reset()
    } else if (e.key === "Enter" && !this.activeItem) {
      this.activate(0)
    } else if (e.key === "Enter") {
      this.activeItem.click()
    }
    if (e.key === "ArrowDown") {
      e.preventDefault()
      let menuItems = this.menuItems()
      this.deactivate(menuItems)
      this.activate(menuItems.indexOf(this.activeItem) + 1, 0)
    } else if (e.key === "ArrowUp") {
      e.preventDefault()
      let menuItems = this.menuItems()
      this.deactivate(menuItems)
      this.activate(menuItems.indexOf(this.activeItem) - 1, menuItems.length - 1)
    } else if (e.key === "Tab") {
      e.preventDefault()
    }
  }
}


hooks.Tippy = TippyHook;
hooks.CopyToClipboard = CopyToClipboardHook;
hooks.WaveSurferHook = WaveSurferHook;
hooks.StripeElementsHook = StripeElementsHook;
hooks.StripeElementsExistingCardHook = StripeElementsExistingCardHook;

// the duration for each toast to stay on screen in ms
const duration = 4000
// const duration = 60000

// how many toasts to show on screen at once
const maxItems = 5

const liveToastHook = createLiveToastHook(duration, maxItems)
hooks.LiveToast = liveToastHook

console.log("loading liveview.js 2");

console.log("liveview!!!!");

let liveSocketErrorSent = false;
window.liveSocketErrorSent = liveSocketErrorSent;

let liveSocket = new LiveSocket("/live", Socket, {
  dom: {
    onBeforeElUpdated(from, to) {
      if (from._x_dataStack) {
        window.Alpine.clone(from, to);
      }
      FluxonDOM.onBeforeElUpdated(from, to);
    },
  },
  hooks: { ...hooks, ...FluxonHooks },
  params: { _csrf_token: csrfToken },
  logger: (kind, msg, data) => console.log(`${kind}: ${msg}`, data),
  // transport: LongPoll
});
liveSocket.socket.onError((error) => {
  // TODO: take a look at doing this, https://github.com/phoenixframework/phoenix/issues/4330#issuecomment-870024336
  if (liveSocketErrorSent) {
    // nothing
  } else {
    const message = "LiveView Socket Error";
    console.log(message, error);
    liveSocketErrorSent = true;
    Honeybadger.notify(error, {
      message: message,
      name: "LiveView",
    });
  }
});

// start of topbar
import topbar from "topbar";
topbar.config({ barColors: { 0: "#29d" }, shadowColor: "rgba(0, 0, 0, .3)" });
let topBarScheduled = undefined;

window.addEventListener("phx:page-loading-start", () => {
  if (!topBarScheduled) {
    topBarScheduled = setTimeout(() => topbar.show(), 200);
  }
});

window.addEventListener("phx:page-loading-stop", () => {
  clearTimeout(topBarScheduled);
  topBarScheduled = undefined;
  topbar.hide();
});
// end of topbar

window.addEventListener("phx:live_reload:attached", ({ detail: reloader }) => {
  // Enable server log streaming to client. Disable with reloader.disableServerLogs()
  reloader.enableServerLogs();

  // Open configured PLUG_EDITOR at file:line of the clicked element's HEEx component
  //
  //   * click with "c" key pressed to open at caller location
  //   * click with "d" key pressed to open at function component definition location
  let keyDown;
  window.addEventListener("keydown", (e) => (keyDown = e.key));
  window.addEventListener("keyup", (e) => (keyDown = null));
  window.addEventListener(
    "click",
    (e) => {
      if (keyDown === "c") {
        e.preventDefault();
        e.stopImmediatePropagation();
        reloader.openEditorAtCaller(e.target);
      } else if (keyDown === "d") {
        e.preventDefault();
        e.stopImmediatePropagation();
        reloader.openEditorAtDef(e.target);
      }
    },
    true
  );
  window.liveReloader = reloader;
});

liveSocket.connect();
// liveSocket.on
// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)
window.liveSocket = liveSocket;

window.addEventListener(`phx:hide_modal`, (e) => {
  // console.log("hide modal", e.detail.id);
  let el = document.querySelector(e.detail.id);
  if (el) {
    liveSocket.execJS(el, el.getAttribute("data-hide"));
  }
});

// Accessible focus handling
// let Focus = {
//   focusMain() {
//     let target =
//       document.querySelector("main h1") || document.querySelector("main");
//     if (target) {
//       let origTabIndex = target.tabIndex;
//       target.tabIndex = -1;
//       target.focus();
//       target.tabIndex = origTabIndex;
//     }
//   },
//   // Subject to the W3C Software License at https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
//   isFocusable(el) {
//     if (
//       el.tabIndex > 0 ||
//       (el.tabIndex === 0 && el.getAttribute("tabIndex") !== null)
//     ) {
//       return true;
//     }
//     if (el.disabled) {
//       return false;
//     }

//     switch (el.nodeName) {
//       case "A":
//         return !!el.href && el.rel !== "ignore";
//       case "INPUT":
//         return el.type != "hidden" && el.type !== "file";
//       case "BUTTON":
//       case "SELECT":
//       case "TEXTAREA":
//         return true;
//       default:
//         return false;
//     }
//   },
//   // Subject to the W3C Software License at https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
//   attemptFocus(el) {
//     if (!el) {
//       return;
//     }
//     if (!this.isFocusable(el)) {
//       return false;
//     }
//     try {
//       el.focus();
//     } catch (e) {}

//     return document.activeElement === el;
//   },
//   // Subject to the W3C Software License at https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
//   focusFirstDescendant(el) {
//     for (let i = 0; i < el.childNodes.length; i++) {
//       let child = el.childNodes[i];
//       if (this.attemptFocus(child) || this.focusFirstDescendant(child)) {
//         return true;
//       }
//     }
//     return false;
//   },
//   // Subject to the W3C Software License at https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
//   focusLastDescendant(element) {
//     for (let i = element.childNodes.length - 1; i >= 0; i--) {
//       let child = element.childNodes[i];
//       if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
//         return true;
//       }
//     }
//     return false;
//   },
// };

// let routeUpdated = () => {
//   Focus.focusMain();
// };

// // Accessible routing
// window.addEventListener("phx:page-loading-stop", routeUpdated);

window.addEventListener("phx:js:exec", (e) => {
  console.log("execccccing", e.detail.cmd);
  liveSocket.execJS(liveSocket.main.el, e.detail.cmd);
});

window.addEventListener("js:call", (e) =>
  e.target[e.detail.call](...e.detail.args)
);

window.addEventListener("phx:js-exec", ({ detail }) => {
  document.querySelectorAll(detail.to).forEach((el) => {
    liveSocket.execJS(el, el.getAttribute(detail.attr));
  });
});
// window.addEventListener("js:focus", (e) => {
//   let parent = document.querySelector(e.detail.parent);
//   if (parent && isVisible(parent)) {
//     e.target.focus();
//   }
// });
// window.addEventListener("js:focus-closest", (e) => {
//   let el = e.target;
//   let sibling = el.nextElementSibling;
//   while (sibling) {
//     if (isVisible(sibling) && Focus.attemptFocus(sibling)) {
//       return;
//     }
//     sibling = sibling.nextElementSibling;
//   }
//   sibling = el.previousElementSibling;
//   while (sibling) {
//     if (isVisible(sibling) && Focus.attemptFocus(sibling)) {
//       return;
//     }
//     sibling = sibling.previousElementSibling;
//   }
//   Focus.attemptFocus(el.parent) || Focus.focusMain();
// });
// window.addEventListener("phx:remove-el", (e) =>
//   document.getElementById(e.detail.id).remove()
// );
